import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Grid from "@mui/material/Grid";
import Typography from '@mui/material/Typography';
import { useUsuarios } from "../State/UsuarioContext";
import CircularIndeterminate from "../../Componentes/CircularIndeterminate";

export default function ModalVerPerfil({ userUid }) {
    const { fetchUsuarioBuscado, usuario } = useUsuarios();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function getUser() {
            setLoading(true);
            await fetchUsuarioBuscado(userUid);
            setLoading(false);
        }
        getUser();
    }, [userUid]);

    const renderField = (label, value) => (
        value ? (
            <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2">{label}:</Typography>
                <Typography variant="body1">{value}</Typography>
            </Grid>
        ) : null
    );

    return (
        <Box sx={{ py: 3 }}>
            {loading ? (
                <Grid container justifyContent="center" alignItems="center">
                    <CircularIndeterminate />
                </Grid>
            ) : (
                <Grid container spacing={2}>
                    {renderField("Nombre", usuario.nombre)}
                    {renderField("Apellido", usuario.apellido)}
                    {renderField("Nombre de Usuario", usuario.uid)}
                    {renderField("Email UTN", usuario.frbaEmail)}
                    {renderField("Email Personal", usuario.personalEmail)}
                    {renderField("Legajo Alumno", usuario.legajoAlumno)}
                    {renderField("Fecha de Nacimiento", usuario.fechaNacimiento)}
                    {renderField("Nacionalidad", usuario.nacionalidad)}
                    {renderField("Estado Civil", usuario.estadoCivil)}
                    {renderField("Tel. Domicilio", usuario.telefonoDomiciliario)}
                    {renderField("Tel. Celular", usuario.telefonoCelular)}
                    {renderField("Sexo", usuario.Sexo?.nombre)}
                    {renderField("Documento", usuario.DocumentoDeIdentificacion?.numero)}
                    {renderField("Tipo de Documento", usuario.DocumentoDeIdentificacion?.TipoDocumentoDeIdentificacion?.nombre)}
                    {renderField("Dirección", `${usuario.Direccion?.calle} ${usuario.Direccion?.altura}, ${usuario.Direccion?.ciudad}, ${usuario.Direccion?.provincia} (${usuario.Direccion?.codigoPostal})`)}
                </Grid>
            )}
        </Box>
    );
}
